module.exports = __webpack_public_path__ + "static/media/paintin-nails.29aab1e9.png";